import { postRequest } from '../clients/axios';

export const postLogin = async (email: string, password: string) => {
  const url = 'Token/login';
  const payload = {
    email,
    password,
  };
  const response = await postRequest<string>(url, payload);
  return response.data;
};
